<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.shift }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable
              :items="items"
              :fields="fields"
              responsive
              sorter
              column-filter
              hover
              show-empty
              :loading="loading"
              @update:column-filter-value="onFilter($event)"
            >
              <template #warna="{ item }">
                <td class="text-center">
                  <b-button
                    :style="`background-color: ${item.warna}; `"
                  ></b-button>
                </td>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  >
                    <CIcon name="cil-pencil" />
                  </b-button>
                  <!-- <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                  >
                    <CIcon name="cil-trash" />
                  </b-button> -->
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input :listMitra="listMitra" :listKategoriShift="listKategoriShift" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :listMitra="listMitra" :listKategoriShift="listKategoriShift" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "shift",
  data() {
    return {
      data: {},
      listMitra: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaCabang",
          label: "Cabang",
          sortDirection: "desc",
          _style: "max-width: 20%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaKategoriShift",
          label: "Kategori Shift",
          sortDirection: "desc",
          _style: "max-width: 20%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaShift",
          label: "Nama Shift",
          sortDirection: "desc",
          _style: "max-width: 20%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaLembur",
          label: "Lembur",
          sortDirection: "desc",
          _style: "width: 15%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaJam",
          label: "Jam",
          sortDirection: "desc",
          _style: "width: 10%;",
          _classes: "text-left",
          filter: false,
          sorter: false,
        },
        {
          key: "namaNominalUpah",
          label: "Upah",
          sortDirection: "desc",
          _style: "width: 15%;",
          _classes: "text-right",
          filter: false,
          sorter: false,
        },
        {
          key: "warna",
          label: "Warna",
          sortDirection: "desc",
          _style: "width: 5%;",
          _classes: "text-center",
          filter: false,
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          _classes: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      listCabang: [],
      listLembur: [],
      listKategoriShift: [
        { namaKategoriShift: "OPENING", warna: "#8db6ea", lembur: false },
        { namaKategoriShift: "CLOSING", warna: "#f3cdd4", lembur: false },
        { namaKategoriShift: "FULL", warna: "#9cefd1", lembur: true },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    if(this.$store.state.role_aktif.kodeRole == 'super'){
      this.fields.splice(1, 0, { 
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      })
    }
    this.getDatas();
    // this.getCabang();
    // this.getMasterLembur();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = {...vm.filter, ...x};
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listShift = await vm.$axios.post("masterShift/listPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listShift", listShift);
      vm.items = listShift.data.status == 200 ? listShift.data.data.map((x, idx) => { 
        vm.listKategoriShift.forEach((item) => {
          if (x.kategoriShift == item.namaKategoriShift) {
            x.kategoriShift = item
          }
        });
        return {
          ...x,
          no: (vm.currentPage - 1) * vm.perPage + idx + 1,
          id: x.masterShiftId,
          namaLembur: x.namaLembur || '-',
          namaJam: vm.$moment(x.jamMasuk, 'HH:mm:ss').format('HH:mm') + ' - ' + vm.$moment(x.jamKeluar, 'HH:mm:ss').format('HH:mm'),
          namaNominalUpah: vm.$numberFormat(x.nominalUpah, 'idr'),
          namaMitra: x.namaMitra || ' - ',
          //edit
          mitra: null,
          koordinator: null,
          cabang: null,
          lembur: {namaLembur: x.namaLembur || '-', masterlemburId: x.masterlemburId},
          namaKategoriShift: x.kategoriShift.namaKategoriShift,
        }
      }): [];
      // console.log("vm.items", vm.items);
      vm.totalRows = parseInt(listShift.data.count);
      vm.loading = false;

      let listMitra = await vm.$axios.get("mitra/list");
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];
    },
    // async getCabang() {
    //   let vm = this;
    //   const listCabang = await vm.$axios.post("cabang/list")
    //   vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : []; 
    // },
    // async getMasterLembur() {
    //   let vm = this;
    //   const listLembur = await vm.$axios.get("masterLembur/list")
    //   vm.listLembur = listLembur.data.status == 200 ? listLembur.data.data : []; 
    //   console.log('listLembur: ', listLembur)
    // },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({name, data}){
      this[name] = data
    }
  },
};
</script> 